import React from 'react';

//components
import EducationWisc from './EducationWisc';
import EducationIdaho from './EducationIdaho';

export default class Education extends React.Component {

  constructor(props) {
    super(props);
    this.showCarrot=true;
    this.state = {
    };
  }
  componentWillMount(){
    if(this.props.showCarrot===false){
      this.showCarrot=false;
    }
  }
  componentDidMount(){
    //determine whether to expand card info
    if(this.props.expanded===true){
      this.expandAllCards();
    }//else keep hidden
  }
  expandAllCards(){
    this.refs.EducationWisc.handleExpand();
    this.refs.EducationIdaho.handleExpand();
  }
  render() {
    return (
      <div className="content-main">
        <EducationWisc
          ref="EducationWisc"
          showCarrot={this.showCarrot}
        />
        <EducationIdaho
          ref="EducationIdaho"
          showCarrot={this.showCarrot}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Education.js